/** @format */

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HmfTextLinkComponent } from '@dsg-tech/homefield-angular';
import { HomefieldIconLibraryModule } from '@dsg-tech/homefield-angular-icons';

@Component({
	selector: 'pdp-component-warranty-plan-cta-wrapper',
	imports: [CommonModule, HmfTextLinkComponent, HomefieldIconLibraryModule],
	templateUrl: './warranty-plan-cta-wrapper.component.html',
	styleUrl: './warranty-plan-cta-wrapper.component.scss'
})
export class WarrantyPlanCtaWrapperComponent {}
